import { AddItemTrackingNumberState } from './addItemTrackingNumber.types'

const initialState: AddItemTrackingNumberState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
